import { withI18n } from 'panda-i18n';
import locale from '@/locale';
import { error, help, hide, loading, notice, show, success, warning, } from './func';
import { CnMessage as RawMessage } from './message';
import './index.scss';
// @ts-ignore
const ExpandedMessage = withI18n(RawMessage, {
    locale,
    _noHoc: true,
});
ExpandedMessage.show = show;
ExpandedMessage.hide = hide;
ExpandedMessage.success = success;
ExpandedMessage.error = error;
ExpandedMessage.notice = notice;
ExpandedMessage.help = help;
ExpandedMessage.loading = loading;
ExpandedMessage.warning = warning;
ExpandedMessage.displayName = 'CnMessage';
export default ExpandedMessage;
export const CnMessage = ExpandedMessage;
